;(function() {
  var $hero = $('#nx-pdp-hero');
  var $heroInfo = $hero.find('#nx-pdp-hero-info-content');
  var $heroGallery = $hero.find('#nx-pdp-hero-gallery-content');
  var $galleryMain = $('#nx-pdp-gallery-main');
  var $galleryThumbs = $('#nx-pdp-gallery-thumbs');

  var $specsLink = $('a[href="#product-specs"]');
  var $specsSection = $('#nx-pdp-specs');

  var $mainNav = $('#nx-header');
  var $subnav = $('#nx-pdp-subnav');
  var $subnavLinks = $('#nx-pdp-navlinks');
  var $subnavAnchors = $subnavLinks.find('a[href^="#"]');
  var $subnavSlot = $('#nx-subnav-target');

  var $vidPlayer = $('#nx-vidplayer-target'); // original modal player
  var $videoTriggers = $('[data-pdp-video-trigger]');

  var plyrLoaded = false;
  var plyrPlaying = false;
  var plyrInstance = null;

  function handleVideos() {
    var playVideo = (id, $parent) => {
      var plyr = new Plyr(id, {
        controls: ['play-large', 'play'],
        autoplay: true,
        hideControls: false,
        youtube: { rel: 0, showinfo: 0, modestbranding: 1 }
      });
      plyr.play();
      $parent.addClass('is-playing');
      plyrInstance = plyr;
      plyrPlaying = true;
    }

    $videoTriggers.click(function(event) {
      event.preventDefault();
      var target = $(this).data('pdp-video-trigger');
      if (!target) return;
      var targetId = '#' + target;
      var $parent = $(targetId).closest('.pdp-player-parent');
      if (!plyrLoaded) {
        $('<link>').appendTo('head').attr({
          type: 'text/css',
          rel: 'stylesheet',
          href: 'https://cdnjs.cloudflare.com/ajax/libs/plyr/3.7.8/plyr.min.css'
        });
        $.getScript('https://cdnjs.cloudflare.com/ajax/libs/plyr/3.7.8/plyr.min.js', function() {
          plyrLoaded = true;
          playVideo(targetId, $parent);
        });
      } else {
        playVideo(targetId, $parent);
      }
    })
  }

  function videoForceAutoplay() {
    const observer = new MutationObserver(function(mutation, observer) {
      const $btn = $vidPlayer.find('button[data-plyr="play"]');
      if ($btn.length) {
        window.setTimeout(function() {
          $btn.click();
        }, 2000);
      }
    });
    observer.observe($vidPlayer[0], { childList: true })
  }

  function initSubnav() {
    $subnav.detach().appendTo($subnavSlot);

    var subnavHeight = $subnav.outerHeight();
    $hero.css({ paddingTop: subnavHeight + 'px' });

    $subnavAnchors.each(function() {
      var $this = $(this);
      $this.click(function(e) {
        e.preventDefault();
        var $section = $($this.attr('href'));
        var sectionTop = $section.offset().top;
        var goingUp = window.scrollY > sectionTop;
        var offset = goingUp ? subnavHeight + $mainNav.outerHeight() : subnavHeight;
        $('html').animate({ scrollTop: $section.offset().top - offset }, 650);
      });
    });

    function highlightActiveItem() {
      $subnavAnchors.each(function() {
        var $this = $(this);
        var $section = $($this.attr('href'));
        if ($section.length && $section.offset() && window.scrollY + window.innerHeight > $section.offset().top) {
          $subnavAnchors.removeClass('is-active');
          $this.addClass('is-active');
        }
      });
    }

    highlightActiveItem();
    window.setInterval(highlightActiveItem, 350);
  }

  function setHeroStickyCols() {
    var threshold = 99;
    var galleryHeight = $heroGallery.outerHeight();
    var infoHeight = $heroInfo.outerHeight();
    if (galleryHeight >= infoHeight + threshold) {
      $hero.addClass('is-sticky-info');
    }
    if (infoHeight >= galleryHeight + threshold) {
      $hero.addClass('is-sticky-gallery');
    }
  }

  function centerThumbnails(resize) {
    var $thumbs = $galleryThumbs.find('figure');
    var thumbsParentWidth = $galleryThumbs.width();
    var thumbsWidth = ($thumbs.length - 1) * 8;
    $thumbs.each(function() {
      thumbsWidth += $(this).width();
    });
    if (thumbsWidth < thumbsParentWidth) {
      $galleryThumbs.css({ maxWidth: thumbsWidth + 'px' });
    }
    if (resize) {
      $galleryThumbs.flickity('resize');
    }
  }

  function initHero() {
    centerThumbnails();
    $galleryMain.flickity({
      lazyLoad: true,
      pageDots: false,
      wrapAround: true,
      adaptiveHeight: true,
      fullscreen: true
    });
    $galleryMain.on('settle.flickity', function() {
      if (plyrInstance) {
        plyrInstance.pause();
      }
    });
    $galleryThumbs.flickity({
      cellAlign: 'left',
      asNavFor: $galleryMain[0],
      pageDots: false,
      prevNextButtons: false,
      contain: true,
      wrapAround: true
    });
    setHeroStickyCols();
    $galleryMain.on('fullscreenChange.flickity', function(event, pointer) {
      setTimeout(() => {
        $galleryMain.flickity('resize');
        $galleryMain.flickity('reposition');
        $galleryThumbs.flickity('resize');
        $galleryThumbs.flickity('reposition');
      }, 500);
    });
  }

  function handleSpecs() {
    $specsLink.click(function(e) {
      e.preventDefault();
      $('html').animate({ scrollTop: $specsSection.offset().top }, 650);
    });
  }

  function resizeHandlers() {
    var timeout = null;
    $(window).resize(function() {
      if (timeout) window.clearTimeout(timeout);
      timeout = window.setTimeout(function() {
        //resize handlers here
        $hero.css({ paddingTop: $subnav.outerHeight() + 'px' });
        centerThumbnails(true);
      }, 250);
    })
  }

  function pdpInit() {
    initSubnav();
    initHero();
    handleSpecs();
    videoForceAutoplay();
    handleVideos();
    resizeHandlers();
  }

  pdpInit();
})();